import React from 'react';

import { Outer, Inner, Wrapper } from './Controls.styles.js';

const Controls = props => (
  <Outer direction={props.direction} tutorialLevel={props.tutorialLevel} tutorialStarted={props.tutorialStarted}>
    <Inner valign={props.valign + ' ' + props.align}>
      <Wrapper direction={props.direction}>{props.children}</Wrapper>
    </Inner>
  </Outer>
);

Controls.defaultProps = {
  direction: 'left',
  valign: 'middle',
  align: 'center'
};

export default Controls;
